import PageVisibilityService from './PageVisibility';

export default { Visibility: PageVisibilityService };